import React from 'react'
import { useTrans } from 'hooks'
import { Breadcrumbs, Button, WContainer } from 'components/atoms'
import { FormCalcolaDataNascita, Page } from 'components/organisms'
import styles from './CalcoloDataNascitaTemplate.module.sass'
import { PaginaType } from 'utils/types'

interface Props {
  pagina: PaginaType
}

const CalcoloDataNascitaTemplate = ({ pagina }: Props) => {
  const t = useTrans()

  return (
    <Page pagina={pagina} item={pagina}>
      <WContainer>
        <div className={styles.breadcrumbs}>
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
        </div>
      </WContainer>
      <WContainer variant="xs">
        <div className={styles.main}>
          <h1 className={styles.title}>{pagina.titolo}</h1>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: pagina.descrizione,
            }}
          />
          <FormCalcolaDataNascita />
          {/* <div
            dangerouslySetInnerHTML={{
              __html: t(
                'Cara mamma,<br /><br />registrandoti al Programma &lt;&lt;Liberi di diventare grandi con Mellin&gt;&gt; potrai vivere la tua grande avventura con il supporto del nostro team e seguire la tua gravidanza settimana per settimana attraverso le nostre newsletter personalizzate!<br /><br />Cosa aspetti?'
              ),
            }}
          />
          <Button
            className={styles.register}
            label={t('Registrati subito')}
            href="/registrazione"
          /> */}
        </div>
        {/* <div className={styles.sidebar}>
          <SideCtaBox
            label={t('Curve di crescita')}
            href="/dashboard"
            imageUrl={getImageUrl('curve-crescita-box.jpg')}
          />
        </div> */}
      </WContainer>
    </Page>
  )
}

export default CalcoloDataNascitaTemplate
